export default class MethodMark {
  constructor(className, methodName) {
    this.name  = className ? `${className}#${methodName}` : `#${methodName}`
    this.start = `${this.name}#begin`
    this.end   = `${this.name}#end`
  }
}

